import listActions from 'src/modules/eventTimeZone/list/eventTimeZoneListActions';
import EventTimeZoneService from 'src/modules/eventTimeZone/eventTimeZoneService';
import Errors from 'src/modules/shared/error/errors';
import { i18n } from 'src/i18n';
import { getHistory } from 'src/modules/store';
import Message from 'src/view/shared/message';

const prefix = 'EVENTTIMEZONE_DESTROY';

const eventTimeZoneDestroyActions = {
  DESTROY_STARTED: `${prefix}_DESTROY_STARTED`,
  DESTROY_SUCCESS: `${prefix}_DESTROY_SUCCESS`,
  DESTROY_ERROR: `${prefix}_DESTROY_ERROR`,

  DESTROY_ALL_STARTED: `${prefix}_DESTROY_ALL_STARTED`,
  DESTROY_ALL_SUCCESS: `${prefix}_DESTROY_ALL_SUCCESS`,
  DESTROY_ALL_ERROR: `${prefix}_DESTROY_ALL_ERROR`,

  doDestroy: (id) => async (dispatch) => {
    try {
      dispatch({
        type: eventTimeZoneDestroyActions.DESTROY_STARTED,
      });

      await EventTimeZoneService.destroyAll([id]);

      dispatch({
        type: eventTimeZoneDestroyActions.DESTROY_SUCCESS,
      });

      Message.success(
        i18n('entities.eventTimeZone.destroy.success'),
      );

      dispatch(listActions.doFetchCurrentFilter());

      getHistory().push('/event-time-zone');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: eventTimeZoneDestroyActions.DESTROY_ERROR,
      });
    }
  },

  doDestroyAll: (ids) => async (dispatch) => {
    try {
      dispatch({
        type: eventTimeZoneDestroyActions.DESTROY_ALL_STARTED,
      });

      await EventTimeZoneService.destroyAll(ids);

      dispatch({
        type: eventTimeZoneDestroyActions.DESTROY_ALL_SUCCESS,
      });

      if (listActions) {
        dispatch(listActions.doClearAllSelected());
        dispatch(listActions.doFetchCurrentFilter());
      }

      Message.success(
        i18n('entities.eventTimeZone.destroyAll.success'),
      );

      getHistory().push('/event-time-zone');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: eventTimeZoneDestroyActions.DESTROY_ALL_ERROR,
      });
    }
  },
};

export default eventTimeZoneDestroyActions;
